import { faExclamationCircle, faCircleQuestion } from '@awesome.me/kit-3777c2145e/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormControl, FormText, FormGroup, FormLabel } from 'react-bootstrap';
import { classNames } from '../../utils/class-names.js';
import { InfoPopup } from '../../components/InfoPopup/InfoPopup.js';

/**
 * Label
 * Info
 * Field
 * Error
 */ class FormItemTemplateNormal extends React.PureComponent {
    isValidationShow() {
        const { readOnly, invalid, error, touched } = this.props;
        if (!error) {
            return false;
        }
        return !!(!readOnly && invalid && touched);
    }
    renderInfo() {
        const { info, error } = this.props;
        const showError = this.isValidationShow();
        return showError ? /*#__PURE__*/ React.createElement(FormControl.Feedback, {
            type: "invalid"
        }, /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
            className: "me-1",
            icon: faExclamationCircle
        }), error) : !!info && /*#__PURE__*/ React.createElement(FormText, {
            as: "div",
            className: "text-body-secondary"
        }, info);
    }
    render() {
        const { label, field, className, infoTooltip, required } = this.props;
        const showError = this.isValidationShow();
        const formGroupClassName = classNames("form-group", showError && "has-danger", className);
        let aliasLabel = null;
        if (label) {
            if (infoTooltip) {
                aliasLabel = /*#__PURE__*/ React.createElement(InfoPopup, {
                    as: FormLabel,
                    tooltip: infoTooltip
                }, label, required && /*#__PURE__*/ React.createElement("span", {
                    className: "form-required-indicator"
                }), /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
                    icon: faCircleQuestion,
                    className: "ms-1"
                }));
            } else {
                aliasLabel = /*#__PURE__*/ React.createElement(FormLabel, null, label, " ", required && /*#__PURE__*/ React.createElement("span", {
                    className: "form-required-indicator"
                }));
            }
        }
        return /*#__PURE__*/ React.createElement(FormGroup, {
            className: formGroupClassName
        }, aliasLabel, field, this.renderInfo());
    }
}

export { FormItemTemplateNormal };
//# sourceMappingURL=FormItemTemplateNormal.js.map
